export const resign_alt = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <path
            id="path848"
            d="M3.5,13.362C7.016,2.711,7.524,1.288,7.887,1.1c.473-.246,1.029-.026,1.433.567.273.4.159.784-3.732,12.585L2.044,25l-1.022-.506L0,23.988ZM8.419,8.941l1.941-5.888.569-.03C12.3,2.949,14.819,2.876,16.037,5c1.011,2.984,5.723,3.357,7.111,3.682l.853.2-1.909,5.789-1.909,5.789-.552.029a5.18,5.18,0,0,1-4.993-2.056c-2.394-4.648-5.8-3.871-7.457-3.681l-.7.081Z"
            transform="translate(0 -1)"
        />
    </svg>
);
